RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Invoices = RivalIQ.data.CacheLayer.extend({
        name: 'Invoices',
        cacheKeys: [
            'account_id'
        ],

        loadData: function (attrs) {
            const invoices = new RivalIQ.collections.Invoices();
            _.extend(invoices, attrs);

            return invoices.fetch().then(function () {
                return invoices;
            });
        },

        fetch: function (account) {
            const me = this;
            account = account || RivalIQ.state.account;

            return me.getOrLoad({
                account_id: account.id
            });
        }
    });

    data.invoices = new Invoices();
});
